var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdatesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "updates-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.2,
    height: 39.2,
    viewBox: "0 0 39.2 39.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1268",
    "data-name": "Rectangle 1268",
    width: 39.2,
    height: 39.2,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5101",
    "data-name": "Path 5101",
    d: "M13.491,5.836l4.257-4.257a1.633,1.633,0,0,1,2.31,0l4.257,4.257h6.021A1.633,1.633,0,0,1,31.97,7.47v6.021l4.257,4.257a1.633,1.633,0,0,1,0,2.31L31.97,24.316v6.021a1.633,1.633,0,0,1-1.633,1.633H24.316l-4.257,4.257a1.633,1.633,0,0,1-2.31,0L13.491,31.97H7.47a1.633,1.633,0,0,1-1.633-1.633V24.316L1.579,20.058a1.633,1.633,0,0,1,0-2.31l4.257-4.257V7.47A1.633,1.633,0,0,1,7.47,5.836ZM9.1,9.1v5.741L5.044,18.9,9.1,22.962V28.7h5.741L18.9,32.762,22.962,28.7H28.7V22.962L32.762,18.9,28.7,14.844V9.1H22.962L18.9,5.044,14.844,9.1Zm9.8,16.333A6.533,6.533,0,1,1,25.436,18.9,6.533,6.533,0,0,1,18.9,25.436Zm0-3.267A3.267,3.267,0,1,0,15.636,18.9,3.267,3.267,0,0,0,18.9,22.17Z",
    transform: "translate(0.534 0.534)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatesIcon);
export default __webpack_public_path__ + "static/media/updates-icon.59325594298a1dde1dcc25b0dd5ee349.svg";
export { ForwardRef as ReactComponent };